import Vue from 'vue'
import gql from 'graphql-tag'
import Component from 'vue-class-component'

import { GeneralAgent } from '@/modules/GeneralAgent/interfaces/general-agent'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'
import GeneralAgentForm from '@/modules/GeneralAgent/components/GeneralAgentForm.vue'
import CarrierProductForm from '@/modules/CarrierProduct/components/CarrierProductForm.vue'
import AppDialog from '@/components/AppDialog.vue'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { deleteCarrierProduct } from '@/modules/CarrierProduct/gql/carrier-product.gql'
import { deleteGeneralAgent } from '@/modules/GeneralAgent/gql/general-agent.gql'

@Component({
  components: {
    GeneralAgentForm,
    AppDialog,
    CarrierProductForm
  }
})
export default class GeneralAgentDialog extends Vue {
  targetGeneralAgent: GeneralAgent | null = null
  targetCarrierProduct: CarrierProduct | null = null
  generalAgentDialog = {
    actionType: 'new',
    show: false,
    title: 'New GeneralAgent',
    disable: false
  }

  deleteGeneralAgentDialog = {
    show: false,
    title: 'Delete GeneralAgent',
    text: ''
  }

  carrierProductDialog = {
    actionType: 'new',
    show: false,
    title: 'New Insurance Product',
    disable: false
  }

  deleteCarrierProductDialog = {
    show: false,
    title: 'Delete Insurance Product',
    text: ''
  }
  disableConfirm = false

  showGeneralAgentEditDialog (e: Event, targetGeneralAgent?: GeneralAgent) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New GeneralAgent'
    if (targetGeneralAgent) {
      this.targetGeneralAgent = targetGeneralAgent
      actionType = 'edit'
      title = 'Edit Progressive'
    }
    this.generalAgentDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideGeneralAgentEditDialog () {
    this.targetGeneralAgent = null
    this.generalAgentDialog = {
      actionType: 'new',
      show: false,
      title: 'New GeneralAgent',
      disable: false
    }
  }

  async deleteGeneralAgent (e: Event, generalAgent: GeneralAgent) {
    e.preventDefault()
    e.stopPropagation()
    this.targetGeneralAgent = generalAgent
    this.deleteGeneralAgentDialog.show = true
  }

  async deleteGeneralAgentPost () {
    if (!this.targetGeneralAgent) {
      return
    }
    const { id } = this.targetGeneralAgent
    this.deleteGeneralAgentDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteGeneralAgent,
        variables: {
          generalAgentId: Number(id)
        }
      })

      const res = result.data.deleteGeneralAgent
      if (res) {
        showNotification({
          msg: 'Delete general-agent successfully',
          type: SnackType.Success
        })
        this.targetGeneralAgent = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  showCarrierProductEditDialog (e: Event, targetCarrierProduct?: CarrierProduct) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Insurance Product'
    if (targetCarrierProduct) {
      this.targetCarrierProduct = targetCarrierProduct
      actionType = 'edit'
      title = 'Edit Renter Policy'
    }
    this.carrierProductDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideCarrierProductEditDialog () {
    this.targetCarrierProduct = null
    this.carrierProductDialog = {
      actionType: 'new',
      show: false,
      title: 'New Insurance Product',
      disable: false
    }
  }

  async deleteCarrierProduct (e: Event, carrierProduct: CarrierProduct) {
    e.preventDefault()
    e.stopPropagation()
    this.targetCarrierProduct = carrierProduct
    this.deleteCarrierProductDialog.show = true
  }

  async deleteCarrierProductPost () {
    if (!this.targetCarrierProduct) {
      return
    }
    const { id } = this.targetCarrierProduct
    this.deleteCarrierProductDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteCarrierProduct,
        variables: {
          carrierProductId: Number(id)
        }
      })

      const res = result.data.deleteCarrierProduct
      if (res) {
        showNotification({
          msg: 'Delete insurance product successfully',
          type: SnackType.Success
        })
        this.targetCarrierProduct = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
